export default __webpack_public_path__ + "static/create-submenu-1b208a8f645027483992c396218aeff7.png";